export const dateHoursFormat = 'dd.MM.yyyy, HH:mm';
